import type { Clip } from '../clip.ts';
import { CLIPS as allies } from './allies.ts';
import { CLIPS as bosses } from './bosses.ts';
import { CLIPS as dragon } from './dragon.ts';
import { CLIPS as nightmares } from './nightmares.ts';
import { CLIPS as siege } from './siege.ts';
import { CLIPS as mourner } from './mourner.ts';
import { CLIPS as ogre } from './ogre.ts';
import { CLIPS as crow } from './crow.ts';
import { CLIPS as hawk } from './hawk.ts';
import { CLIPS as giant } from './giant.ts';
import { CLIPS as slinger } from './slinger.ts';
import { CLIPS as troll } from './troll.ts';
import { CLIPS as beetle } from './beetle.ts';
import { CLIPS as tenaza } from './tenaza.ts';
import { CLIPS as barrena } from './barrena.ts';
import { CLIPS as bannerman } from './bannerman.ts';
import { CLIPS as bonesinger } from './bonesinger.ts';
import { CLIPS as wyvern } from './wyvern.ts';
import { CLIPS as moth } from './moth.ts';
import { CLIPS as weaver } from './weaver.ts';
import { CLIPS as spiderling } from './spiderling.ts';
import { CLIPS as sima } from './sima.ts';
import { CLIPS as oracle } from './oracle.ts';
import { CLIPS as wyrmling } from './wyrmling.ts';
import { CLIPS as mammoth } from './mammoth.ts';
import { CLIPS as uro } from './uro.ts';
import { CLIPS as sentinel } from './sentinel.ts';
import { CLIPS as corvin } from './corvin.ts';
import { CLIPS as kaela } from './kaela.ts';
import { CLIPS as lucan } from './lucan.ts';
import { CLIPS as edda } from './edda.ts';
import { CLIPS as vela } from './vela.ts';
import { CLIPS as ansel } from './ansel.ts';
import { CLIPS as bruni } from './bruni.ts';
import { CLIPS as ragna } from './ragna.ts';
import { CLIPS as frostColossus } from './frost-colossus.ts';
import { CLIPS as stormHerald } from './storm-herald.ts';
import { CLIPS as shellSerpent } from './shell-serpent.ts';
import { CLIPS as glassDrake } from './glass-drake.ts';
import { CLIPS as shellback } from './shellback.ts';
import { CLIPS as lidlessDreamer } from './lidless-dreamer.ts';
import { CLIPS as ashWatcher } from './ash-watcher.ts';
import { CLIPS as prestado } from './prestado.ts';
import { CLIPS as leechMother } from './leech-mother.ts';
import { CLIPS as simaProps } from './sima-props.ts';
import { CLIPS as marrowWormClips } from './marrow-worm.ts';
import { CLIPS as broodQueen } from './brood-queen.ts';
import { CLIPS as bellows } from './bellows.ts';
import { CLIPS as archivist } from './archivist.ts';
import { CLIPS as prism } from './prism.ts';
import { CLIPS as frostLady } from './frost-lady.ts';
import { CLIPS as sporeMother } from './spore-mother.ts';
import { CLIPS as rootking } from './rootking.ts';
import { CLIPS as sunken } from './sunken.ts';
import { CLIPS as caza } from './caza.ts';

/**
 * Every non-human rig's clips, by kind: the nightmare kinds of `enemy:<kind>` (goblin, wolf, witch, dragon,
 * dragonAir…), `bot:<kind>` as `bot:automaton`, `golem` and `bear`.
 */
export const CREATURE_CLIPS: Record<string, () => Clip[]> = { ...nightmares, ...siege, ...bosses, ...dragon, ...allies, ...mourner, ...ogre, ...crow, ...hawk, ...giant, ...slinger, ...troll, ...beetle, ...bannerman, ...bonesinger, ...wyvern, ...moth, ...weaver, ...spiderling, ...oracle, ...wyrmling, ...mammoth, ...uro, ...sentinel, ...corvin, ...kaela, ...frostColossus, ...stormHerald, ...shellSerpent, ...glassDrake, ...shellback, ...lidlessDreamer, ...ashWatcher, ...prestado, ...leechMother, ...simaProps, ...marrowWormClips, ...broodQueen, ...bellows, ...archivist, ...prism, ...frostLady, ...sporeMother, ...rootking, ...lucan, ...edda, ...vela, ...ansel, ...bruni, ...ragna, ...sima, ...sunken, ...tenaza, ...barrena, ...caza };
